import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { trimmed } from './_checks.js';
import { draftFields } from './_shared.js';
import { activityIssue, asList, asRecord } from './types.js';

const issue = activityIssue('scroll_card');

export const CardItem = z.looseObject({
  heading: z.string().optional(),
  content: z.string().optional(),
  backgroundImageUrl: z.string().optional(),
});

/**
 * A deck the player scrolls to the end of before moving on. The background image is
 * genuinely optional — the seed ships a card with an empty one — so it is not checked.
 */
export const scrollCard: ActivityDefinition = {
  type: 'scroll_card',
  summary: 'A deck of headed cards, finishing with one outcome once the player scrolls to the last card.',
  setup: z.looseObject({
    ...draftFields,
    cardItems: z.array(CardItem).optional(),
  }),
  check: (setup, ctx) => {
    const items = asList(setup.cardItems);
    if (!items.length) {
      return [issue('empty', 'No cards are written — there is nothing to scroll.', [...ctx.path, 'setup', 'cardItems'], ctx)];
    }

    const issues = [];
    for (const [index, raw] of items.entries()) {
      const item = asRecord(raw);
      const path = [...ctx.path, 'setup', 'cardItems', index];
      if (!trimmed(item.heading)) {
        issues.push(issue('itemHeading', `Card ${index + 1} has no heading.`, [...path, 'heading'], ctx, raw));
      }
      if (!trimmed(item.content)) {
        issues.push(issue('itemContent', `Card ${index + 1} has no copy on it.`, [...path, 'content'], ctx, raw));
      }
    }
    return issues;
  },
};
